<template lang="pug">
//- Jake - 1/26/21
//- We still need this base class because other components target this to add margin
//- I don't know why we have an ID on this but I left it for now
//- Answer: ID is used by pages/catalog as scroll target for scrollToTopOfResults() - Jordan 2/4/21
.fitment-inline(
    v-if="!hasFullFitment"
    id="fitment-inline"
)
    div(class="lg:container")
        div(class="flex flex-wrap flex-col lg:flex-row lg:items-center")
            div(
                class="px-3 pt-3 pb-3"
                :class="[ getSelectCount === 4 ? 'lg:pb-0 lg:w-full xl:pb-3 xl:w-auto xl:flex-1' : 'lg:flex-1' ]"
            )
                p(class="text-2xl font-bold uppercase leading-none text-center xl:text-lg")
                    | Select Your
                    span(class="xl:hidden") &nbsp;
                    span(class="xl:block xl:text-black xl:font-extrabold xl:text-4xl") Vehicle

            div(
                class="px-3 lg:py-3 xl:w-2/3"
                :class="[ getSelectCount === 4 ? 'lg:w-4/5' : 'lg:w-1/2' ]"
            )
                div(class="lg:flex lg:flex-wrap" data-testid="fitmentInline")
                    template(v-for="select in requiredSelectTypes")
                        Select(
                            :select="select"
                            :currentValue="select.currentValue"
                            @changed="selectChanged"
                            class="mx-auto pb-1 max-w-md lg:max-w-none lg:p-1 lg:mx-0"
                            :class="[ getSelectCount === 4 ? 'lg:flex-1' : 'lg:w-1/3' ]"
                        )

            div(class="px-3 py-3 text-center lg:flex-1")
                BaseButton(
                    @click.native="saveFitment(true)"
                    :isDisabled="!allDoneSelecting"
                    class="disabled:bg-gray-light disabled:text-white"
                    data-testid="fitmentInlineSave"
                ) Shop Now

</template>

<script>
import BaseButton from '@/components/baseButton'
import Select from './_components/select'
import fitmentMixin from './_mixins/fitment'

export default {
    name: 'FitmentInline',
    components: {
        Select,
        BaseButton,
    },
    mixins: [fitmentMixin],
    computed: {
        hasFullFitment() {
            return this.$store.getters['fitment/hasFullFitment']
        },
        getSelectCount() {
            return this.requiredSelectTypes.length
        },
    },
    mounted() {
        this.layoutPosition = 'inline'
    },
}
</script>
